var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5C10 17.7812 9.75 18 9.5 18C9.21875 18 9 17.7812 9 17.5V11C9 10.75 9.21875 10.5 9.5 10.5C9.75 10.5 10 10.75 10 11V17.5ZM12.5 17.5C12.5 17.7812 12.25 18 12 18C11.7188 18 11.5 17.7812 11.5 17.5V11C11.5 10.75 11.7188 10.5 12 10.5C12.25 10.5 12.5 10.75 12.5 11V17.5ZM15 17.5C15 17.7812 14.75 18 14.5 18C14.2188 18 14 17.7812 14 17.5V11C14 10.75 14.2188 10.5 14.5 10.5C14.75 10.5 15 10.75 15 11V17.5ZM14.9062 5.78125L16.0625 7.5H18.25C18.6562 7.5 19 7.84375 19 8.25C19 8.6875 18.6562 9 18.25 9H18V18.5C18 19.9062 16.875 21 15.5 21H8.5C7.09375 21 6 19.9062 6 18.5V9H5.75C5.3125 9 5 8.6875 5 8.25C5 7.84375 5.3125 7.5 5.75 7.5H7.90625L9.0625 5.78125C9.375 5.3125 9.9375 5 10.5312 5H13.4375C14.0312 5 14.5938 5.3125 14.9062 5.78125ZM9.71875 7.5H14.25L13.6562 6.625C13.625 6.5625 13.5312 6.5 13.4375 6.5H10.5312C10.4375 6.5 10.3438 6.5625 10.3125 6.625L9.71875 7.5ZM7.5 18.5C7.5 19.0625 7.9375 19.5 8.5 19.5H15.5C16.0312 19.5 16.5 19.0625 16.5 18.5V9H7.5V18.5Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.f89f5a02a664d53b01cf5427cd15475d.svg";
export { ForwardRef as ReactComponent };